/* eslint-disable max-lines */
import { color } from 'styles/colors'

const INDOOR_LEGEND_ITEMS = [
  {
    label: 'Cooling Setpoint',
    seriesName: 'cooling',
    shortLabel: 'Cool. S.P.',
    emptyDataSet: true,
    tooltip: '',
    strokeDasharray: '2, 2',
    stroke: color('legendIndoor'),
    strokeWidth: '3',
    strokeLineCap: 'butt',
    visible: true,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'Heating Setpoint',
    seriesName: 'heating',
    shortLabel: 'Heat. S.P.',
    emptyDataSet: true,
    tooltip: '',
    strokeDasharray: '3, 3',
    stroke: color('legendIndoor'),
    strokeWidth: '3',
    strokeLineCap: 'butt',
    visible: true,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'ID Temperature',
    seriesName: 'indoorTemp',
    shortLabel: 'Temp.',
    emptyDataSet: true,
    tooltip: '',
    strokeDasharray: '8 0',
    stroke: color('legendIndoor'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: true,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'ID Relative Humidity',
    seriesName: 'indoorHumidity',
    shortLabel: 'Rel. Hum.',
    emptyDataSet: true,
    tooltip: '',
    strokeDasharray: '16, 2, 3 ',
    stroke: color('legendIndoor'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: true,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  }
]

const INDOOR_ZONE_LEGEND_ITEMS = INDOOR_LEGEND_ITEMS.concat({
  label: 'Relieving',
  seriesName: 'relieving',
  shortLabel: 'Relieving',
  emptyDataSet: true,
  tooltip: '',
  strokeDasharray: '',
  stroke: color('legendRelieving'),
  strokeWidth: '6',
  strokeLineCap: 'round',
  visible: true,
  x1: '3',
  y1: '3',
  x2: '16',
  y2: '3'
})

const OUTDOOR_LEGEND_ITEMS = [
  {
    label: 'OD Temperature',
    seriesName: 'outdoorTemp',
    shortLabel: '',
    emptyDataSet: true,
    tooltip: '',
    strokeDasharray: '',
    stroke: color('legendOutdoor'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: true,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'OD Relative Humidity',
    seriesName: 'outdoorHumidity',
    shortLabel: '',
    emptyDataSet: true,
    tooltip: '',
    strokeDasharray: '20,2,2',
    strokeWidth: '6',
    stroke: color('legendOutdoor'),
    strokeLineCap: 'butt',
    visible: true,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  }
]

const OUTDOOR_UNIT_LEGEND_ITEMS = [
  {
    label: 'Liquid Pressure',
    seriesName: 'liquidPressure',
    shortLabel: '',
    emptyDataSet: true,
    tooltip: '',
    strokeDasharray: '24,0',
    stroke: color('legendOdLiquidPressure'),
    strokeLineCap: 'butt',
    strokeWidth: '6',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'Liquid Temp',
    seriesName: 'odLiquidTemp',
    shortLabel: '',
    emptyDataSet: true,
    tooltip: '',
    strokeDasharray: '24,0',
    stroke: color('legendOdLiquidTemp'),
    strokeLineCap: 'butt',
    strokeWidth: '6',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'OD Subcool',
    seriesName: 'odSubcool',
    shortLabel: '',
    emptyDataSet: true,
    tooltip: '',
    strokeDasharray: '24,0',
    stroke: color('legendOdSubCool'),
    strokeLineCap: 'butt',
    strokeWidth: '6',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'Suction Pressure',
    seriesName: 'odSuctionPressure',
    shortLabel: '',
    tooltip: 'Suction Pressure at the outdoor coil',
    emptyDataSet: true,
    strokeDasharray: '24,0',
    stroke: color('legendOdSuctionPressure'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'Suction Temp',
    seriesName: 'suctionTemperature',
    shortLabel: '',
    emptyDataSet: true,
    tooltip: '',
    strokeDasharray: '24,0',
    stroke: color('legendOdSuctionTemperature'),
    strokeLineCap: 'butt',
    strokeWidth: '6',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'OD Superheat',
    seriesName: 'odSuperheat',
    shortLabel: '',
    tooltip: 'Superheat at the outdoor coil',
    emptyDataSet: true,
    strokeDasharray: '24,0',
    stroke: color('legendOdSuperheat'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'OD EEV Position',
    seriesName: 'odEevStepPosition',
    shortLabel: '',
    tooltip: '',
    emptyDataSet: true,
    strokeDasharray: '24,0',
    stroke: color('legendOdEevStepColor'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'OD Coil Temp',
    seriesName: 'odCoilTemp',
    shortLabel: '',
    tooltip: '',
    emptyDataSet: true,
    strokeDasharray: '24,0',
    stroke: color('legendOdCoilTemp'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  }
]

const INDOOR_UNIT_LEGEND_ITEMS = [
  {
    label: 'Actual Airflow',
    seriesName: 'actualAirflow',
    shortLabel: '',
    tooltip: 'Indoor blower delivered airflow',
    emptyDataSet: true,
    strokeDasharray: '14, 2, 3, 2 ',
    stroke: color('indoorUnitActualAirflow'),
    strokeLineCap: 'butt',
    strokeWidth: '6',
    visible: false,
    x1: '0',
    y1: ' 0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'ID Superheat',
    seriesName: 'gasSuperheat',
    shortLabel: '',
    tooltip: 'Superheat at the indoor coil',
    emptyDataSet: true,
    strokeDasharray: '2, 2, 2, 2, 16',
    strokeLineCap: 'butt',
    strokeWidth: '6',
    stroke: color('legendIdSuperHeat'),
    visible: false,
    x1: '0',
    y1: '0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'Gas Temp',
    seriesName: 'gasTemp',
    shortLabel: '',
    tooltip: 'Indoor coil gas line temperature',
    emptyDataSet: true,
    strokeDasharray: '2, 3, 19',
    strokeLineCap: 'butt',
    strokeWidth: '6',
    stroke: color('legendGasTemp'),
    visible: false,
    x1: '0',
    y1: '0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'Evap/Liquid Temp',
    seriesName: 'coilTemp',
    shortLabel: '',
    tooltip: 'While cooling: Indoor coil evaporator temperature\n' +
             'While heating: Liquid temperature leaving indoor coil',
    emptyDataSet: true,
    strokeDasharray: '1,3, 20',
    stroke: color('legendIdCoilTemp'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: false,
    x1: '0',
    y1: '0',
    x2: '24',
    y2: '0'
  }
]

const CONTROL_HUB_INDOOR_UNIT_LEGEND_ITEMS = [
  {
    label: 'ID EEV Steps',
    seriesName: 'idEevStep',
    shortLabel: '',
    emptyDataSet: true,
    tooltip: '',
    strokeDasharray: '',
    stroke: color('legendIdEevStepColor'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: false,
    x1: '0',
    y1: '0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'ID Return Air Temp',
    seriesName: 'idReturnAirTemp',
    shortLabel: '',
    emptyDataSet: true,
    tooltip: '',
    strokeDasharray: '',
    stroke: color('legendIdReturnAirTempColor'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: false,
    x1: '0',
    y1: '0',
    x2: '24',
    y2: '0'
  },
  {
    label: 'ID Supply Air Temp',
    seriesName: 'idSupplyAirTemp',
    shortLabel: '',
    emptyDataSet: true,
    tooltip: '',
    strokeDasharray: '',
    stroke: color('legendIdSupplyAirTempColor'),
    strokeWidth: '6',
    strokeLineCap: 'butt',
    visible: false,
    x1: '0',
    y1: '0',
    x2: '24',
    y2: '0'
  }
]

const LegendConfig = {
  INDOOR_LEGEND_ITEMS,
  INDOOR_UNIT_LEGEND_ITEMS,
  INDOOR_ZONE_LEGEND_ITEMS,
  OUTDOOR_LEGEND_ITEMS,
  OUTDOOR_UNIT_LEGEND_ITEMS,
  CONTROL_HUB_INDOOR_UNIT_LEGEND_ITEMS
}

export default LegendConfig
